/* eslint-disable jsx-a11y/aria-role */
import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'

import Clients from '../clients/pages/index'
import Dashboard from '../home/pages/index'
import Details from '../home/pages/Details'
import ServiceCategory from '../service-category/pages/index'
import ServiceType from '../service-type/pages/index'
import Users from '../users/pages/new-index.jsx'
import KnowWay from '../knowWay/pages/index'
import PaymentMethod from '../payment-type/pages/index'
import Attendance from '../attendance/pages/new_index.jsx'
import Calendar from '../callendar/pages/index'
import BirthRelatory from '../birthRelatory/pages/index'
import CatalogacaoRelatory from '../catalogacaoRelatory/pages/index'
import ClientsRelatory from '../clientsRelatory/pages/index'
import TechnicalAbsencesRelatory from '../technicalAbsencesRelatory/pages/index'
import ProspectsRelatory from '../prospectsRelatory/pages/index'
import ServicesRelatory from '../servicesRelatory/pages/index'
import SchedulesRelatory from '../schedulesRelatory/pages/index'
import TeamProdutivityRelatory from '../teamProdutivityRelatory/pages/index'
import ServiceCategoriesRelatory from '../serviceCategoriesRelatory/pages/index'
import FinancialRelatory from '../financialRelatory/pages/index'
import Supplier from '../supplier/pages/index'
import BillingType from '../billingType/pages/index'
import Billing from '../billing/pages/index'
import FinancialDashboard from '../financialDashboard/pages/index'
import LaundryClient from '../laundryClients/pages/index'
import laundryClientBillings from '../laundryClientBillings/pages/index'
import ClientPlan from '../clientPlan/pages/new-index.jsx'
import Bank from '../bank/pages/index'
import BankReport from '../bank-report/pages/index'
import Settings from '../settings/pages/index'
import EditLaundry from '../edit-laundryClient'
import LeadsDashboard from '../leadsDashboard/pages/index'
import ReadyItems from '../home/pages/ReadyItems'
import Edit from '../attendance/pages/Edit'
import AttendanceNew from '../attendance/pages/New'
import NewClient from '../clients/pages/New'
import EditClient from '../clients/pages/Edit'
import Subscription from '../subscription/pages'
import NewLaundryClient from '../laundryClients/pages/New'
import EditLaundryClient from '../laundryClients/pages/Edit'
import SubscriptionAdmin from '../subscription/pages/admin'
import Alerts from '../alerts/pages'
import Stock from '../stock/pages'
import StockRelatory from '../StockRelatory/pages'
import ProductHistory from '../productHistory/pages'
import RelatoryCommission from '../relatoryCommission/pages'
import Produtivity from '../teamProdutivityRelatory/pages/Produtivity'
import LaundryEletronicInvoice from '../laundry-eletronic-invoice/pages'
import EletronicInvoice from '../attendance/pages/EletronicInvoice'
import Triggers from '../crm/triggers/pages'
import CrmPanel from '../crm/panel/pages'
import LeadsReport from '../crm/reports/leads/pages'
import GerencyReport from '../crm/reports/gerency/pages'
import Dre from '../dre/pages'
import Laundries from '../partners-module/partners/pages/index.jsx'
import NewLaundry from '../partners-module/partners/pages/Components/New'
import EditLaundryPage from '../partners-module/partners/pages/Components/Edit.js'
import Visualization from '../partners-module/partners/pages/Components/Visualization.js'

import PartnersOss from '../partners-module/oss/pages/index.js'
import Appointments from '../partners-module/appointments/pages/index.jsx'
import OsDetails from '../partners-module/oss/pages/Details/Details.js'
import PartnersDashboard from '../partners-module/dashboard/pages/index'

import ItemsReport from '../partners-module/items-report/pages/index'
import ItemHistory from '../attendance/pages/ItemHistory.js'
import ItemHistoryByBarcode from '../attendance/pages/ItemHistoryByBarcode.js'
import AttendanceHistory from '../attendance/pages/History'
import ReadyItemsLaundry from '../home/pages/ReadyItemsLaundry.js'
import PasswordReset from '../password-reset/pages/index.jsx'
import { ImportServiceTypes } from '../service-type/pages/import/index.jsx'
import { ImportClients } from '../clients/pages/import/index.jsx'
import { CreateEditUser } from '../users/pages/create-edit/index.jsx'
import OverdueItems from '../home/pages/OverdueItems.jsx'
import { Conversion } from '../cashback-module/conversion/pages/index.js'
import Extract from '../cashback-module/extract/pages/index.jsx'
import ExtractDetails from '../cashback-module/extract/pages/details/index.js'
import PointValue from '../cashback-module/point-value/pages/index.jsx'
import ServiceTypes from '../partners-module/partners/pages/ServiceTypes/index.jsx'

function findPermission(roles, permissions, permissionUser = []) {
  if (!roles) return 0
  return permissionUser.filter(x => roles.includes(x.name)).length
  // return (
  //   permissions.filter(x => x.name === roles[0]).length ||
  //   permissionUser.filter(x => x.name === roles[0]).length
  // )
}

function findEmail(emails, user) {
  if (!emails) return 0
  return emails?.filter(email => user?.email === email).length
}

function findRoles(roles, userRole) {
  if (!roles) return 0
  // userRole pode vir como objeto único ou array de roles (state.auth.role)
  const list = Array.isArray(userRole) ? userRole : [userRole]
  return roles?.filter(role => list.some(x => x?.name === role)).length
}

const redirectByRole = userRole => {
  if (userRole?.name === 'lavanderia')
    return <Redirect to="/laundry-dashboard" />

  return <Redirect to="/" />
}

export const redirectByPermission = permission => {
  if (permission[0]?.name === 'read-finance-module') {
    return <Redirect to="/financial" />
  }
}

const PrivateRouteWrapper = props => {
  const {
    permissions,
    permissionUser,
    role,
    emails,
    user,
    userRole,
    rolesAllowed,
    ...routeProps
  } = props

  if (
    findPermission(role, permissions, permissionUser) ||
    findEmail(emails, user) ||
    findRoles(rolesAllowed, userRole)
  ) {
    return <Route {...routeProps} />
  }
  return redirectByRole(userRole)
}

const PrivateRoute = connect(state => ({
  permissions: state.auth.permissions,
  permissionUser: state.auth.permissionUser,
  user: state.auth.user,
  userRole: state.auth.role,
}))(PrivateRouteWrapper)

const Routes = () => {
  return (
    <Switch>
      <PrivateRoute
        role={['create-usuarios']}
        path="/users/new"
        component={CreateEditUser}
      />

      <PrivateRoute
        role={['create-laundry-client']}
        path="/laundry-clients/new"
        component={NewLaundryClient}
      />
      <PrivateRoute
        role={['update-laundry-client']}
        path="/laundry-clients/:id/edit"
        component={EditLaundryClient}
      />
      <PrivateRoute
        rolesAllowed={['administrador']}
        path="/laundry-clients/:id/subscription"
        component={SubscriptionAdmin}
      />
      <PrivateRoute
        rolesAllowed={['administrador']}
        path="/alerts"
        component={Alerts}
      />
      <PrivateRoute
        role={[
          'read-gatilhos',
          'create-gatilhos',
          'update-gatilhos',
          'delete-gatilhos',
        ]}
        path="/crm/triggers"
        component={Triggers}
      />
      <PrivateRoute
        role={[
          'read-painel-crm',
          'create-painel-crm',
          'update-painel-crm',
          'delete-painel-crm',
        ]}
        path="/crm/panel"
        component={CrmPanel}
      />
      <PrivateRoute
        role={[
          'read-modulo-parceiros',
          'create-modulo-parceiros',
          'update-modulo-parceiros',
          'delete-modulo-parceiros',
        ]}
        path="/partners-module/partners"
        component={Laundries}
      />

      <PrivateRoute
        role={['read-relatorio-leads']}
        path="/crm/reports/leads"
        component={LeadsReport}
      />
      <PrivateRoute
        role={['read-relatorio-gerencial']}
        path="/crm/reports/gerency"
        component={GerencyReport}
      />
      <PrivateRoute
        role={['read-modulo-nfse']}
        path="/attendance/eletronic-invoice/:id"
        component={EletronicInvoice}
      />
      <PrivateRoute
        role={['update-usuarios']}
        path="/users/:id/edit"
        component={CreateEditUser}
      />

      <PrivateRoute
        role={['read-clientes']}
        path="/clients/import"
        component={ImportClients}
      />

      <PrivateRoute
        role={['read-relatorios-producao-equipe']}
        path="/relatory-team-produtivity/:id"
        component={Produtivity}
      />
      <Route path="/users/:id/see/:see" component={CreateEditUser} />
      <PrivateRoute
        exact
        role={['read-dashboard-itens']}
        path="/"
        component={Dashboard}
      />

      <PrivateRoute
        role={['read-ready-items']}
        path="/details/ready"
        component={ReadyItems}
      />

      <PrivateRoute
        role={['read-ready-items']}
        path="/details/overdue"
        component={OverdueItems}
      />

      <PrivateRoute
        role={['read-ready-items']}
        path="/details/laundry/ready"
        component={ReadyItemsLaundry}
      />
      <PrivateRoute
        role={['read-dashboard-financeiro']}
        path="/dashboard-financial"
        component={FinancialDashboard}
      />
      <PrivateRoute
        role={['read-dashboard-leads']}
        path="/lead"
        component={LeadsDashboard}
      />
      <Route path="/details/:id" component={Details} />
      <Route path="/details/late" component={Details} />
      <PrivateRoute
        role={[
          'read-usuarios',
          'create-usuarios',
          'update-usuarios',
          'delete-usuarios',
        ]}
        path="/users"
        component={Users}
      />
      <PrivateRoute
        role={['create-atendimentos']}
        path="/attendance/new"
        component={AttendanceNew}
      />
      <PrivateRoute
        role={['update-atendimentos']}
        path="/attendance/:id/edit"
        component={Edit}
      />
      <PrivateRoute
        role={['read-atendimentos']}
        path="/service-item/history/:id"
        component={ItemHistory}
      />
      <PrivateRoute
        role={['read-atendimentos']}
        path="/service-item-history"
        component={ItemHistoryByBarcode}
      />

      <PrivateRoute
        role={['create-clientes']}
        path="/clients/new"
        component={NewClient}
      />
      <PrivateRoute
        role={['update-clientes']}
        path="/clients/:id/edit"
        component={EditClient}
      />
      <PrivateRoute
        role={[
          'read-como-conheceu',
          'create-como-conheceu',
          'update-como-conheceu',
          'delete-como-conheceu',
        ]}
        path="/knowWay"
        component={KnowWay}
      />
      <PrivateRoute
        role={[
          'read-categorias-servico',
          'create-categorias-servico',
          'update-categorias-servico',
          'delete-categorias-servico',
        ]}
        path="/service-category"
        component={ServiceCategory}
      />
      <PrivateRoute
        role={[
          'read-laundry-client',
          'create-laundry-client',
          'update-laundry-client',
          'delete-laundry-client',
        ]}
        path="/laundry-clients"
        component={LaundryClient}
      />
      <PrivateRoute
        role={['laundry-client-billing-list']}
        path="/laundry-client-billings"
        component={laundryClientBillings}
      />
      <PrivateRoute
        role={['read-dre', 'create-dre', 'update-dre', 'delete-dre']}
        path="/dre"
        component={Dre}
      />
      <PrivateRoute
        role={[
          'read-clientes',
          'create-clientes',
          'update-clientes',
          'delete-clientes',
        ]}
        path="/clients"
        component={Clients}
      />

      <PrivateRoute
        role={['read-tipos-servico']}
        path="/service-type/import"
        component={ImportServiceTypes}
      />
      <PrivateRoute
        role={[
          'read-tipos-servico',
          'create-tipos-servico',
          'update-tipos-servico',
          'delete-tipos-servico',
        ]}
        path="/service-type"
        component={ServiceType}
      />
      <PrivateRoute
        role={[
          'read-formas-pagamento',
          'create-formas-pagamento',
          'update-formas-pagamento',
          'delete-formas-pagamento',
        ]}
        path="/payment-method"
        component={PaymentMethod}
      />
      <PrivateRoute
        role={[
          'read-atendimentos',
          'create-atendimentos',
          'update-atendimentos',
          'delete-atendimentos',
        ]}
        path="/attendance"
        component={Attendance}
      />
      <PrivateRoute
        role={['read-calendario']}
        path="/calendar/:id?"
        component={Calendar}
      />
      <PrivateRoute
        role={[
          'read-estoque',
          'create-estoque',
          'update-estoque',
          'delete-estoque',
        ]}
        path="/stock"
        component={Stock}
      />
      <PrivateRoute
        role={['read-estoque']}
        path="/product-history/:id"
        component={ProductHistory}
      />
      <PrivateRoute
        role={['read-relatorios-aniversariantes']}
        path="/relatory-birth"
        component={BirthRelatory}
      />
      <PrivateRoute
        role={['read-relatorios-catalogacao']}
        path="/relatory-catalogacao"
        component={CatalogacaoRelatory}
      />
      <PrivateRoute
        role={['read-relatorios-estoque']}
        path="/relatory-stock"
        component={StockRelatory}
      />
      <PrivateRoute
        role={['read-relatorios-comissao']}
        path="/relatory-commission"
        component={RelatoryCommission}
      />
      <PrivateRoute
        role={['read-relatorios-clientes']}
        path="/relatory-clients"
        component={ClientsRelatory}
      />
      <PrivateRoute
        role={['read-relatorios-ausencia-tecnicos']}
        path="/relatory-technical-absences"
        component={TechnicalAbsencesRelatory}
      />
      <PrivateRoute
        role={['read-relatorios-prospects']}
        path="/relatory-prospects"
        component={ProspectsRelatory}
      />
      <PrivateRoute
        role={['read-relatorios-atendimentos']}
        path="/relatory-services"
        component={ServicesRelatory}
      />
      <PrivateRoute
        role={['read-relatorios-agendamento']}
        path="/relatory-schedules"
        component={SchedulesRelatory}
      />
      <PrivateRoute
        role={['read-relatorios-categoria-servicos']}
        path="/relatory-service-category"
        component={ServiceCategoriesRelatory}
      />
      <PrivateRoute
        role={['read-relatorios-producao-equipe']}
        path="/relatory-team-produtivity"
        component={TeamProdutivityRelatory}
      />
      {/* <PrivateRoute
        role={['read-financial-relatory']}
        path="/relatory-financial"
        component={FinancialRelatory}
      /> */}
      <PrivateRoute
        role={[
          'read-contatos-financeiros',
          'create-contatos-financeiros',
          'update-contatos-financeiros',
          'delete-contatos-financeiros',
        ]}
        path="/supplier"
        component={Supplier}
      />
      <PrivateRoute
        role={[
          'read-centro-custo',
          'create-centro-custo',
          'update-centro-custo',
          'delete-centro-custo',
        ]}
        path="/billing-type"
        component={BillingType}
      />
      <PrivateRoute
        role={[
          'read-lancamento-contas',
          'create-lancamento-contas',
          'update-lancamento-contas',
          'delete-lancamento-contas',
        ]}
        path="/billing"
        component={Billing}
      />
      <PrivateRoute
        role={['client-plan-list']}
        path="/client-plan"
        component={ClientPlan}
      />
      {/* <PrivateRoute
        role={['read-bank-report']}
        path="/bank-report"
        component={BankReport}
      /> */}

      <PrivateRoute
        role={[
          'read-bancos',
          'create-bancos',
          'update-bancos',
          'delete-bancos',
        ]}
        path="/bank"
        component={Bank}
      />

      <PrivateRoute
        role={[
          'read-configuracoes',
          'create-configuracoes',
          'update-configuracoes',
          'delete-configuracoes',
        ]}
        path="/settings"
        component={Settings}
      />
      <PrivateRoute
        role={['gerency-update-laundry-client']}
        path="/edit-laundry"
        component={EditLaundry}
      />
      <PrivateRoute
        role={['read-modulo-nfse']}
        path="/laundry-eletronic-invoice"
        component={LaundryEletronicInvoice}
      />
      <PrivateRoute
        role={['read-dashboard-itens']}
        path="/reset-password"
        component={PasswordReset}
      />
      <PrivateRoute
        role={['gerency-update-laundry-client']}
        path="/subscription"
        component={Subscription}
      />

      {/* Cashback Module */}
      <PrivateRoute
        role={[
          'read-cashback-conversao',
          'create-cashback-conversao',
          'update-cashback-conversao',
          'delete-cashback-conversao',
        ]}
        path="/cashback-module/conversion"
        component={Conversion}
      />

      <Route
        role={['read-cashback-extrato']}
        path="/cashback-module/extract/details/:id"
        component={ExtractDetails}
      />

      <PrivateRoute
        role={[
          'read-cashback-extrato',
          'create-cashback-extrato',
          'update-cashback-extrato',
          'delete-cashback-extrato',
        ]}
        path="/cashback-module/extract"
        component={Extract}
      />

      <PrivateRoute
        role={[
          'read-cashback-valor-ponto',
          'create-cashback-valor-ponto',
          'update-cashback-valor-ponto',
          'delete-cashback-valor-ponto',
        ]}
        path="/cashback-module/point-value"
        component={PointValue}
      />

      {/* Partners Module */}
      <PrivateRoute
        role={['create-modulo-parceiros']}
        path="/partners-module/partner/new"
        component={NewLaundry}
      />

      <PrivateRoute
        role={['update-modulo-parceiros']}
        path="/partners-module/partner/edit/:id"
        component={EditLaundryPage}
      />

      <PrivateRoute
        role={['read-modulo-parceiros']}
        path="/partners-module/partner/visualization/:id"
        component={Visualization}
      />

      <PrivateRoute
        role={['read-modulo-parceiros']}
        path="/partners-module/partner/service-types/:id"
        component={ServiceTypes}
      />

      <PrivateRoute
        role={[
          'read-modulo-parceiros-oss',
          'create-modulo-parceiros-oss',
          'update-modulo-parceiros-oss',
          'delete-modulo-parceiros-oss',
        ]}
        path="/partners-module/oss"
        component={PartnersOss}
      />

      <PrivateRoute
        role={[
          'read-modulo-parceiros-agendamentos',
          'create-modulo-parceiros-agendamentos',
          'update-modulo-parceiros-agendamentos',
          'delete-modulo-parceiros-agendamentos',
        ]}
        path="/partners-module/appointments"
        component={Appointments}
      />

      <PrivateRoute
        role={[
          'read-modulo-parceiros-oss',
          'create-modulo-parceiros-oss',
          'update-modulo-parceiros-oss',
          'delete-modulo-parceiros-oss',
        ]}
        path="/partners-module/os/:id"
        component={OsDetails}
      />

      <PrivateRoute
        role={['read-modulo-parceiros-dashboard']}
        path="/partners-module/dashboard"
        component={PartnersDashboard}
      />

      <PrivateRoute
        role={['read-modulo-parceiros-relatorio-itens']}
        path="/partners-module/items-report"
        component={ItemsReport}
      />
      {/* Partners Module */}
      <PrivateRoute exact role={['read-finance-module']} path="/financial" />
      {redirectByRole()}
    </Switch>
  )
}

export default React.memo(Routes)
